import React, { useState, useEffect } from "react";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import "./LikeButton.css"

export default function LikeButton({ id, type, initialLikes }) {
  // type = "product" or "blog"
  const [likes, setLikes] = useState(initialLikes || 0);
  const [liked, setLiked] = useState(false);
  const [cooldown, setCooldown] = useState(false);

  const storageKey = `liked_${type}_${id}`;
  const cooldownKey = `liked_time_${type}_${id}`;

  useEffect(() => {
    // Check if user already liked
    if (localStorage.getItem(storageKey)) {
      setLiked(true);
    }
  }, [storageKey]);

    const handleLike = async () => {
    const analyticsCollection =
        type === "product" ? "analyticsProducts" : "blogAnalytics";
    const ref = doc(db, analyticsCollection, id);

    // Cooldown check (5 seconds)
    const lastLike = localStorage.getItem(cooldownKey);
    if (lastLike && Date.now() - lastLike < 5000) return;

    setCooldown(true);
    localStorage.setItem(cooldownKey, Date.now());

    // --- UNLIKE ---
    if (liked) {
        // Optimistic UI update
        setLikes((prev) => Math.max(prev - 1, 0));
        setLiked(false);

        // Remove from localStorage
        localStorage.removeItem(storageKey);

        // Decrement analytics
        await updateDoc(ref, {
        likes: increment(-1),
        });

        setTimeout(() => setCooldown(false), 5000);
        return;
    }

    // --- LIKE ---
    // Optimistic UI update
    setLikes((prev) => prev + 1);
    setLiked(true);

    // Save to localStorage
    localStorage.setItem(storageKey, "true");

    // Increment analytics
    await updateDoc(ref, {
        likes: increment(1),
        lastLiked: Date.now(),
    });

    setTimeout(() => setCooldown(false), 5000);
    };


  return (
    <button
      onClick={handleLike}
      disabled={cooldown}
      className={`like-button ${liked ? "liked" : ""}`}
    >
      {liked ? "❤️" : "🤍"} {likes}
    </button>
  );
}
